import { useEffect, useMemo, useState } from 'react';
import { Search, X, Plus, ScrollText, Scale } from 'lucide-react';
import './ScrapMobileHome.css';

// iOS WebView Hurda Alım ana görünümü (/mobile/hurda → ScrapPurchase mobileApp modu).
// Liste ve toplamlar ScrapPurchase.js'in kendi verisinden (filteredPurchases, stats) gelir — web ile
// birebir aynı; burada yalnızca telefon yerleşimi var. Karta dokununca web'deki fiş detayı açılır.

const STORES = [
  { id: 1, label: 'Akik Gold' },
  { id: 2, label: 'Osmangazi' },
  { id: 3, label: 'Yeşil Su' },
];

const PAGE_SIZE = 40;

const tl = (n) => `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const gr = (n) => `${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} gr`;

// "Bugün", "Dün" ya da "15 Ekim Çarşamba" — liste gün başlıklarıyla gruplanır
const dayLabel = (date) => {
  const d = new Date(date);
  const today = new Date();
  const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((startOf(today) - startOf(d)) / 864e5);
  if (diff === 0) return 'Bugün';
  if (diff === 1) return 'Dün';
  return d.toLocaleDateString('tr-TR', {
    day: 'numeric', month: 'long', weekday: 'long',
    ...(d.getFullYear() !== today.getFullYear() ? { year: 'numeric' } : {})
  });
};

const ScrapMobileHome = ({
  isAdmin,
  storeId, setStoreId,
  loading,
  purchases,
  stats,
  searchTerm, setSearchTerm,
  getMilyem,
  onOpen, onNew, onOpenLog,
}) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [searchTerm, storeId]);

  // Toplam has gram (listedeki kayıtlar)
  const totalPure = useMemo(
    () => purchases.reduce((sum, p) => sum + Number(p.total_pure_weight || p.pure_weight || 0), 0),
    [purchases]
  );

  const visible = purchases.slice(0, visibleCount);
  const groups = [];
  visible.forEach(p => {
    const label = dayLabel(p.created_at);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(p);
    else groups.push({ label, items: [p] });
  });

  return (
    <div className="smh">
      {/* Mağaza (yalnızca admin) */}
      {isAdmin && (
        <div className="smh-segment" role="tablist">
          {STORES.map(s => (
            <button
              key={s.id}
              type="button"
              role="tab"
              aria-selected={storeId === s.id}
              className={storeId === s.id ? 'is-active' : ''}
              onClick={() => setStoreId(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      )}

      {/* Özet */}
      <div className="smh-hero">
        <div className="smh-hero-main">
          <span className="smh-hero-label">Toplam Ödenen</span>
          <span className="smh-hero-value">{tl(stats.totalAmount)}</span>
        </div>
        <div className="smh-hero-stats">
          <div><span>Alım</span><strong>{stats.total}</strong></div>
          <div><span>Has Toplam</span><strong>{gr(totalPure)}</strong></div>
        </div>
      </div>

      {/* Hızlı işlemler */}
      <div className="smh-actions">
        <button type="button" className="smh-action is-primary" onClick={onNew}>
          <Plus size={18} /> Yeni Alım
        </button>
        <button type="button" className="smh-action" onClick={onOpenLog}>
          <ScrollText size={18} /> İşlem Geçmişi
        </button>
      </div>

      {/* Arama */}
      <div className="smh-search">
        <Search size={17} />
        <input
          type="search"
          inputMode="search"
          placeholder="Müşteri adı veya telefon ara"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button type="button" className="smh-search-clear" onClick={() => setSearchTerm('')} aria-label="Temizle">
            <X size={14} />
          </button>
        )}
      </div>

      {loading && purchases.length === 0 ? (
        <div className="smh-group">
          <div className="smh-card">
            {[0, 1, 2, 3].map(i => <div key={i} className="smh-row smh-skeleton" />)}
          </div>
        </div>
      ) : purchases.length === 0 ? (
        <div className="smh-empty">
          <Scale size={40} />
          <div className="smh-empty-title">Hurda alımı bulunamadı</div>
          <div className="smh-empty-text">Bu mağazada aramaya uygun kayıt yok.</div>
        </div>
      ) : (
        groups.map((group, idx) => (
          <div key={`${group.label}-${idx}`} className="smh-group">
            <div className="smh-day">{group.label}</div>
            <div className="smh-card">
              {group.items.map(p => {
                const metals = p.metal_types || p.metal_type || '';
                const isGold = metals.includes('gold');
                const isSilver = metals.includes('silver');
                const milyem = getMilyem(p);
                const purity = p.purities || p.purity;
                const time = new Date(p.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
                return (
                  <button
                    key={p.group_id || p.id}
                    type="button"
                    className="smh-row"
                    onClick={() => onOpen(p)}
                  >
                    <span className={`smh-icon ${isGold && !isSilver ? 'is-gold' : isSilver && !isGold ? 'is-silver' : 'is-mixed'}`}>
                      <Scale size={18} />
                    </span>
                    <span className="smh-main">
                      <span className="smh-title">{p.customer_name || 'Müşteri yok'}</span>
                      <span className="smh-sub">
                        <span>#{p.store_scrap_number || p.first_id || p.id}</span>
                        <span>· {time}</span>
                        {p.staff_name && <span>· {p.staff_name}</span>}
                      </span>
                      <span className="smh-tags">
                        {isGold && <span className="smh-tag is-gold">Altın</span>}
                        {isSilver && <span className="smh-tag is-silver">Gümüş</span>}
                        {purity && <span className="smh-tag">{purity}{isGold && !String(purity).includes(',') ? ' Ayar' : ''}</span>}
                        {milyem && <span className="smh-tag is-purple">{milyem} Milyem</span>}
                        {p.item_count > 1 && <span className="smh-tag">{p.item_count} kalem</span>}
                      </span>
                    </span>
                    <span className="smh-side">
                      <span className="smh-amount">{tl(p.total_amount)}</span>
                      <span className="smh-weight">{gr(p.total_pure_weight || p.pure_weight)} has</span>
                      {p.payment_method && <span className="smh-method">{p.payment_method}</span>}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))
      )}

      {purchases.length > visibleCount && (
        <button type="button" className="smh-more" onClick={() => setVisibleCount(c => c + PAGE_SIZE)}>
          Daha fazla göster ({purchases.length - visibleCount} kayıt kaldı)
        </button>
      )}
    </div>
  );
};

export default ScrapMobileHome;
